import { render, staticRenderFns } from "./BusinessPromptHistory.vue?vue&type=template&id=172696e2&scoped=true"
import script from "./BusinessPromptHistory.vue?vue&type=script&lang=js"
export * from "./BusinessPromptHistory.vue?vue&type=script&lang=js"
import style0 from "./BusinessPromptHistory.vue?vue&type=style&index=0&id=172696e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172696e2",
  null
  
)

export default component.exports